 var cannotLoadAjax = "Can not process your request";
 var makeText = 'Make';
 var yearText = 'Year';
 var modelText = 'Model';
 var loadingText = 'Loading';
 var engineText = 'Engine';
 var toolText = 'Tool Model';
 var toolIdText = 'Tool ID (optional)';
 var makeTextMX = 'Marca';
 var yearTextMX = 'Año';
 var modelTextMX = 'Modelo';
 var loadingTextMX = 'Cargando';
 var engineTextMX = 'Motor';
 var toolTextMX = 'Modelo de herramienta';
 var toolIdMX = 'ID de herramientas (opcional)';
 var cannotLoadAjaxMX = "No se puede procesar su solicitud";
 const disclaimerMsg =
    '<strong>Disclaimer</strong>: The coverage checker gives a general idea of what your tool can do with your vehicle. Because we update our tools often, what you see here might not match what’s in your tool.<br><br>For the most up-to-date coverage, make sure your tool has the latest firmware before using the coverage checker: <a class="text-danger" href="https://innova-electronics.helpscoutdocs.com/article/2692-innova-obd2-scan-tool-updates" target="_blank" rel="noopener">Update your tool here</a>. We present this information to the best of our knowledge, but it is not guaranteed.';
 const disclaimerMsgMX =
    '<strong>Aviso legal</strong>: El verificador de cobertura ofrece una idea general de lo que su herramienta puede hacer con su vehículo. Dado que actualizamos nuestras herramientas con frecuencia, lo que ve aquí podría no coincidir con lo que tiene su herramienta.<br><br>Para obtener la cobertura más actualizada, asegúrese de que su herramienta tenga el firmware más reciente antes de usar el verificador de cobertura: <a class="text-danger" href="https://innova-electronics.helpscoutdocs.com/article/2692-innova-obd2-scan-tool-updates" target="_blank" rel="noopener">Actualice su herramienta aquí</a>. Presentamos esta información según nuestro mejor conocimiento, pero no está garantizada.';
  
var newTools = [{val:"0x031C",text:"1000"},{val:"0x03AE",text:"3011"},{val:"0x03A3",text:"3013"},{val:"0x03A3",text:"3030"},{val:"0x03AE",text:"5010"},{val:"0x03A9",text:"5110"},{val:"0x03D3",text:"5210"},{val:"0x03C8",text:"5310"}
                 ,{val:"0x03B8",text:"5410"},{val:"0x03C0",text:"5510"},{val:"0x03C1",text:"5512"},{val:"0x03C5",text:"5610"},{val:"0x02D5",text:"7111"},{val:"0x0423",text:"3011RS"},{val:"0x03A9",text:"3020RS"},{val:"0x03AA",text:"3030RS"},{val:"0x03D0",text:"3040RS"}
                 ,{val:"0x03E0",text:"3100RS"},{val:"0x03E1",text:"3120RS"},{val:"0x03B8",text:"3130RS"},{val:"0x03C1",text:"3140RS"},{val:"0x03C8",text:"3150RS"},{val:"0x03C0",text:"3160RS"},{val:"0x03C1",text:"3170RS"},{val:"0x031B",text:"3210RS"}
                  ,{val:"0x031C",text:"3215RS"},{val:"0x03C5",text:"5160RS"},{val:"0x03BB",text:"5300CALAT"},{val:"0x03BA",text:"5300LAT"},{val:"0x031C",text:"6000P"},{val:"0x03D0",text:"6030P"},{val:"0x03E3",text:"6100P"}
                  ,{val:"0x03C8",text:"6200P"},{val:"0x03C0",text:"7100P"},{val:"0x0671",text:"SD29"},{val:"0x0672",text:"SD35"},{val:"0x042F",text:"SD35a"},{val:"0x042E",text:"SD39"},{val:"0x0698",text:"SDS43"},{val:"0x0480",text:"SDS43a"},{val:"0x02D7",text:"SDS50"}]
var newToolsIds = [{sku:"1000", toolids:["0x0318","0x031C","0x0445"]},{sku:"3011", toolids:["0x03AE"]},{sku:"3013", toolids:["0x03A3"]},{sku:"3030", toolids:["0x03F0","0x03AA","0x03A3","0x03A2"]}
  ,{sku:"5010", toolids:["0x03A0","0x03AE","0x0423"]},{sku:"5110", toolids:["0x03A1","0x03AF","0x03A9","0x0422"]},{sku:"5210", toolids:["0x030A","0x03D2","0x03D1","0x03B7","0x03B0","0x03D3","0x0308","0x03D0","0x03D5"]}
   ,{sku:"5310", toolids:["0x03E6","0x03E3","0x03B1","0x03E5","0x03EF","0x03E0","0x030B","0x03C9","0x03C8","0x06A0"]},{sku:"5410", toolids:["0x03B8","0x03B2","0x030C","0x03E9","0x03E2","0x0444"]}
   ,{sku:"5510", toolids:["0x03BE","0x03C0","0x03C3","0x0663"]},{sku:"5512", toolids:["0x03BF","0x03C1","0x03C4","0x0664"]},{sku:"5610", toolids:["0x03C2","0x03C5","0x03DF","0x0665","0x068F"]},{sku:"7111", toolids:["0x02D1","0x02D5","0x02E2","0x0668"]}
   ,{sku:"3011RS", toolids:["0x0423"]},{sku:"3020RS", toolids:["0x03A1","0x03A9","0x03AF", "0x0422"]},{sku:"3030RS", toolids:["0x03A2","0x03A3","0x03AA","0x03F0","0x066F"]},{sku:"3040RS", toolids:["0x0308","0x03B7","0x03D0","0x03D1","0x03D2","0x03D3","0x03D5"]}
   ,{sku:"3100RS", toolids:["0x03B1","0x03E0","0x03E5","0x03EF","0x06A0"]},{sku:"3120RS", toolids:["0x030A","0x03B5","0x03E1","0x03E3","0x03E6","0x03E8"]},{sku:"3130RS", toolids:["0x030C","0x03B8","0x03E2","0x03E9","0x0444"]}   
   ,{sku:"3140RS", toolids:["0x03BF","0x03C1"]},{sku:"3150RS", toolids:["0x030B","0x03B1","0x03C8","0x03C9"]},{sku:"3160RS", toolids:["0x03BE","0x03C0","0x03C3","0x0663"]},{sku:"3170RS", toolids:["0x03BF","0x03C1","0x03C4","0x0664"]}
   ,{sku:"3210RS", toolids:["0x031B","0x0446"]},{sku:"3215RS", toolids:["0x0318","0x031C","0x0445"]},{sku:"5160RS", toolids:["0x03C2","0x03C5","0x03DF"]},{sku:"5300CALAT", toolids:["0x030E","0x03BB"]}
   ,{sku:"5300LAT", toolids:["0x030D","0x03BA"]},{sku:"6000P", toolids:["0x0318","0x031C"]},{sku:"6030P", toolids:["0x0308","0x03D0","0x03D3"]},{sku:"6100P", toolids:["0x030A","0x03B1","0x03E0","0x03E3","0x03E5","0x03E6"]}
   ,{sku:"6200P", toolids:["0x030B","0x03C8","0x03C9"]},{sku:"7100P", toolids:["0x03BE","0x03C0","0x03C3"]},{sku:"SD29", toolids:["0x0671"]},{sku:"SD35", toolids:["0x042F","0x0672"]},{sku:"SD35a", toolids:["0x042F"]},{sku:"SD39", toolids:["0x042E"]}
  ,{sku:"SDS43", toolids:["0x02D6","0x0480","0x0698"]},{sku:"SDS43a", toolids:["0x0480"]},{sku:"SDS50", toolids:["0x02D7","0x02E6"]}];
var obdDisplaySections = "obd1,diagnostics,services,additionalfeatures,livedata,specialfunctions,activetestfunctions";//remove hdobd, empty for all sections
var tabletDisplaySections = "obd1,obd2,oem,workshop"; //remove hdobd, empty for all sections
var tabletTools = ['0x02D5','0x02D6','0x02D7','0x0671','0x0672','0x0698','0x02DE','0x042F','0x042E','0x02D1',"0x0480","0x0668","0x02E2","0x02E6"];
var mxTools = [{val:"0x0672",text:"SD35"}, {val:"0x02D7",text:"SDS50"}];

var currMarket, currYear, currMake, currModel, currEngine, currTool, preTool;

  $(document).ready(function () {     
    $("#errorDiv").addClass("d-none");
    initCoveragePage();
	  toggleCoverage();
    switchSelectedColor("Market"); 
    localizedText();
    
    currMarket = "US";
    $("#Market").change(function () {
      localizedText();
      if(!isSupportOneTool()){
        var loadNewTool = $(this).val() == "US";      
        loadTools(loadNewTool);      
      }
      switchSearchCondition("changeMarket");
      GetYearSelectList();
    });

    $("#Year").change(function () { 
      GetMakeSelectList();
      switchSelectedColor("Year");      
    });

    $("#Make").change(function () { 
      GetModelSelectList();
      switchSelectedColor("Make");      
    });

    $("#ModelName").change(function () {
      if($("#EngineType").length ){
        GetEngineTypeSelectList();
      }
      switchSelectedColor("ModelName");
    });

    $("#EngineType").change(function () { 
      switchSelectedColor("EngineType");      
    });
    
    $("#Tool").change(function () {   
      $("#Year").removeClass("inv-error");
      $("#Make").removeClass("inv-error");
      $("#ModelName").removeClass("inv-error");
      $("#EngineType").removeClass("inv-error");   
      switchSelectedColor("Tool"); 
      loadToolIds();
      
      // var tool = $("#Tool").val();      
      // preTool = tool;
      // if(tool=="oldTool" || tool=="newTool" ){
      //   loadTools(tool=="newTool");       
      //   $("#Tool").parent().find("span.select2-selection__rendered").removeClass("inv-selected");         
      // } else{
      //   if (oldTools.every(item => { return item.val == tool })){
      //       $("#engineTypeContent").addClass("d-none");
      //   } else {
      //       $("#engineTypeContent").removeClass("d-none");
      //   }
      //   switchSelectedColor("Tool"); 
      // }                
    });
    // $('#Tool').on("select2:select", function(e) {   
    //   if(preTool=="oldTool" || preTool=="newTool" ){
    //    $("#Tool").select2("open");
    //   }
    // });

    
     $('#frmCoverage').keypress(function (event) {
        if (event.keyCode == 13) {
            searchCompatibilities();
            return false;
        }
    });
    
  });

function localizedText(){
   var market = GetMarketVal();
   var title =  "COVERAGE CHECKER";
   var subtitle = "Identify which OBD2 tool functions will work on your vehicle.";
   var country = "Country";
   var toolInfo = "Tool Information";
   var vehicleInfo = "Vehicle Information";
   var submit = "Submit";
   var cancel = "Cancel";
   var edit = "Edit";
   var confirm = "Confirm";
   if(market.toLowerCase()=="mx")
   {
      title = "Comprobador de cobertura";
      subtitle = "Identifique qué funciones de la herramienta funcionarán en su vehículo.";
      country = "Pais";
      toolInfo = "Información de la herramienta";
      vehicleInfo = "Intermación del vehicule";
      submit = "Enviar";
      cancel = "Cancelar";
      edit = "Editar";
      confirm = "Confirmar";
   }
   $("#cov-title").html(title);
   $("#cov-subtitle").html(subtitle);
   $("#cov-country").html(country);
   $("#cov-toolInfo").html(toolInfo);
   $("#cov-vehicleInfo").html(vehicleInfo);
   $("#searchCoverageBtn").html(submit);
   $(".cancel-text").html(cancel);
   $(".edit-text").html(edit);
   $(".confirm-text").html(confirm);
  
}

function switchSelectedColor(ctrlId){
  var val =  $("#" + ctrlId).val();
  if(val != ""){
     $("#" + ctrlId).parent().find("span.select2-selection__rendered").addClass("inv-selected");
  }else{
      $("#" + ctrlId).parent().find("span.select2-selection__rendered").removeClass("inv-selected");
  }
}

function switchSelectedInfo(){
  switchSelectedColor("Tool");  
  switchSelectedColor("ToolId"); 
  switchSelectedColor("Market"); 
  switchSelectedColor("Make");
  switchSelectedColor("Year");  
  switchSelectedColor("ModelName"); 
  switchSelectedColor("EngineType");    
}


function initCoveragePage(){
  var detailPage = correctBool($("#ForProductDetail").val());
  
  if(detailPage){	  
	tongleFeatureCoverage();
  }
   else{
    if(!isSupportOneTool()){
       loadTools(true);
    }
     var market = GetMarketVal();
     var url = "/apps/innova-api/coverages/"+ market +"/Years/?r=" + Math.random();
    $.ajax({
        type: "GET",        
        url: url,
        cache: false,
        timeout: 15000,
        error: function (jqXHR, exception) {
            if (jqXHR.status == 404){
              options = "<option value=''>" + getYearText(market) + "</option>";
              $("#Year").html(options).change();
            }else if (jqXHR.status == 400){
              alert(jqXHR.responseJSON.message.description);
            }else{
              alert(getCannotLoadText(market));
            }
        },
        success: function (ret) {
          if (ret.message.success) {
            var result = ret.data;          
            var options = "<option value=''>" + getYearText(market) + "</option>";
            for (var i = 0; i < result.length; i++) {
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
            }
            $("#Year").html(options);
            $("#Make").html("<option value=''>" + getMakeText(market) + "</option>");
            $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");
            $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
            //$("#Year").select2('focus');
          } 
          // else {                                                               
          //     $("#errorDiv").html(ret.message.description);
          //     $("#errorDiv").removeClass("d-none"); 
          // }
          queryDedault();
        }
    });
  	 
   }
  
}

function editVehicle(){
  switchSearchCondition("editVehicle");
}

function editTool(){
  switchSearchCondition("editTool");
}

function editToolIdOpt(){
  switchSearchCondition("editToolIdOpt");
}

function editMarket(){
  switchSearchCondition("editMarket");
}

function cancelVehicleUpdate(){
  switchSearchCondition("cancelVehicleUpdate");
}

function cancelToolUpdate(){
  switchSearchCondition("cancelToolUpdate");
}

function cancelToolIdOptUpdate(){
  switchSearchCondition("cancelToolIdOptUpdate");
}

function cancelMarketUpdate(){
  switchSearchCondition("cancelMarketUpdate");
}

function switchSearchCondition(status){
  var year = $("#Year").val();
  var make = $("#Make").val();
  var model = $("#ModelName").val();
  var engine = $("#EngineType").val();
  var toolId = $("#ToolId").val();
  var tool = $("#Tool option:selected").text();
  var market = $("#Market option:selected").text();
  if(toolId == undefined || toolId == null || toolId == ""){
	toolId = $("#Tool").val();
  }
  switch(status)
  {
    case "editVehicle":
      $("#searchVehicleDiv").removeClass("d-none");
      $("#confirmVehicleDiv").removeClass("d-none");
      $("#editVehicleDiv").addClass("d-none");

      //$("#searchVehicleDiv div").first().removeClass("col-md-12").addClass("col-md-6 col-lg-9");      
      break;
    case "editTool":
      $("#searchToolDiv").removeClass("d-none");
      $("#confirmToolDiv").removeClass("d-none");
      $("#editToolDiv").addClass("d-none");
      break;
	case "editToolIdOpt":
	  $("#ToolId").val(toolId);
      $("#searchToolIdOptDiv").removeClass("d-none");
      $("#confirmToolIdOptDiv").removeClass("d-none");
      $("#editToolIdOptDiv").addClass("d-none");
      break;
    case "editMarket":
      $("#selectMarketDiv").removeClass("d-none");
      $("#cancelMarketBtn").removeClass("d-none");
      $("#editMarketDiv").addClass("d-none");
      $("#selectMarketDiv").addClass("mr-4");
      $("#marketContentDiv").removeClass("col-lg-3").addClass("col-lg-4");
      break;
    case "cancelVehicleUpdate":      
      // if($("#Year").val() != currYear){
      //   $("#Year").val(currYear).change();
      //   switchSelectedColor("Year");
      // }else if($("#Make").val() != currMake){
      //  GetMakeSelectList(currMake);
      // }else if($("#ModelName").val() != currModel){
      //   GetModelSelectList(currModel);        
      // }else if($("#EngineType").val() != currEngine){
      //   $("#EngineType").val(currEngine).change();
      //   switchSelectedColor("EngineType");
      // }

      $("#searchVehicleDiv").addClass("d-none");
      $("#confirmVehicleDiv").addClass("d-none");
      $("#editVehicleDiv").removeClass("d-none");

      //$("#searchVehicleDiv div").first().addClass("col-md-12").removeClass("col-md-6 col-lg-9");       
      break;
    case "cancelToolUpdate":      
      //var option =  $("#Tool").find("option[value='" + currTool + "']").val();
      // if(option == null || option == undefined){
      //   var loadNewTool = oldTools.find(x => x.val === option) ? false : true;
      //   loadTools(loadNewTool);
      // }
      
      //$("#Tool").val(currTool).change();
      $("#searchToolDiv").addClass("d-none");
      $("#confirmToolDiv").addClass("d-none");
      $("#editToolDiv").removeClass("d-none");
      break;
   case "cancelToolIdOptUpdate":
      $("#searchToolIdOptDiv").addClass("d-none");
      $("#confirmToolIdOptDiv").addClass("d-none");
      $("#editToolIdOptDiv").removeClass("d-none");
      break;
   case "cancelMarketUpdate":      
      // var option =  $("#Market").find("option[value='" + currMarket + "']").val();
      // if(option == null || option == undefined){
      //    var loadNewTool = mxTools.find(x => x.val === option) ? false : true;
      //    loadTools(loadNewTool);         
      // }
      // if(option != currMarket){
      //   $("#Market").val(currMarket).change();
      //   GetYearSelectList();
      // }
      $("#selectMarketDiv").removeClass("mr-4");
      $("#marketContentDiv").addClass("col-lg-3").removeClass("col-lg-4");
      $("#cancelMarketBtn").addClass("d-none");
      $("#selectMarketDiv").addClass("d-none");
      $("#editMarketDiv").removeClass("d-none");

      $("#searchVehicleDiv").addClass("d-none");
      $("#confirmVehicleDiv").addClass("d-none");
      $("#editVehicleDiv").removeClass("d-none");
      
      //$("#Tool").val(currTool).change();
      $("#searchToolDiv").addClass("d-none");
      $("#confirmToolDiv").addClass("d-none");
      $("#editToolDiv").removeClass("d-none");
      
      break;
    case "changeMarket":
      $("#searchVehicleDiv").removeClass("d-none");
      $("#confirmVehicleDiv").addClass("d-none");
      $("#editVehicleDiv").addClass("d-none");
      $("#EngineType").parent("div").parent("div").removeClass("d-none");
     // $("#searchVehicleDiv div").first().addClass("col-md-12").removeClass("col-md-6 col-lg-9");       
      
      $("#searchToolDiv").removeClass("d-none");
      $("#confirmToolDiv").addClass("d-none");
      $("#editToolDiv").addClass("d-none");

      $("#searchToolIdOptDiv").removeClass("d-none");
      $("#confirmToolIdOptDiv").addClass("d-none");
      $("#editToolIdOptDiv").addClass("d-none");  

      $("#cancelMarketBtn").addClass("d-none");
      $("#marketContentDiv").addClass("col-lg-3").removeClass("col-lg-4");

      $("#submitDiv").removeClass("d-none");
      $("#results").addClass("d-none");      
      break;
    default:      
      $("#selectedVehicle").html(year + " " + make + " " + model + " " + engine);      
      $("#submitDiv").addClass("d-none");
      $("#searchVehicleDiv").addClass("d-none");
      $("#confirmVehicleDiv").addClass("d-none");
      $("#editVehicleDiv").removeClass("d-none");
      
      $("#selectedTool").html(tool);
	  $("#searchToolDiv").addClass("d-none");
      $("#confirmToolDiv").addClass("d-none");
      $("#editToolDiv").removeClass("d-none");    

	  $("#selectedToolIdOpt").html(toolId);
      $("#searchToolIdOptDiv").addClass("d-none");
      $("#confirmToolIdOptDiv").addClass("d-none");
      $("#editToolIdOptDiv").removeClass("d-none");  
	  
      $("#selectedMarket").html(market);
      $("#selectMarketDiv").addClass("d-none");      
      $("#cancelMarketBtn").addClass("d-none");
      $("#editMarketDiv").removeClass("d-none");    

      $("#results").removeClass("d-none"); 

      $("#marketContentDiv").addClass("col-lg-3").removeClass("col-lg-4");
      //$("#searchVehicleDiv div").first().addClass("col-md-12").removeClass("col-md-6 col-lg-9");       
      break;
  }
}

function validVin() {
    var text = $('#Vin').val().toUpperCase();
    text = text.replace(/Q/g, "0").replace(/O/g, "0").replace(/I/g, "1").replace(/L/g, "1");
    $('#Vin').val(text);
    var vinLength = 17 - $('#Vin').val().length;
    $("#vinCount").html(vinLength);
}

function validateCoverageForm(validEngine) {
	$("#Year").removeClass("required").removeClass("inv-error");
	$("#Make").removeClass("required").removeClass("inv-error");
	$("#ModelName").removeClass("required").removeClass("inv-error");
	$("#EngineType").removeClass("required").removeClass("inv-error");
	$("#Vin").removeClass("required").removeClass("inv-error");
  	$("#Tool").addClass("required");
		
    if (($("#Vin").val() == undefined || $("#Vin").val() == "") && ($("#MakeOnly").val() == undefined || $("#MakeOnly").val() == "")) {
        $("#Year").addClass("required");
        $("#Make").addClass("required");
        $("#ModelName").addClass("required");
        if(validEngine){
          $("#EngineType").addClass("required");
        }else{
          $("#EngineType").removeClass("required").removeClass("inv-error");
        }
        $("#Vin").removeClass("required").removeClass("inv-error");
    } else if($($("#MakeOnly").val() == undefined || "#MakeOnly").val() == ""){
        $("#Year").removeClass("required").removeClass("inv-error");
        $("#Make").removeClass("required").removeClass("inv-error");
        $("#ModelName").removeClass("required").removeClass("inv-error");
        $("#EngineType").removeClass("required").removeClass("inv-error");

        $("#Vin").addClass("required");
    }

    if(!checkRequiredFields('coverageChecker')){
      return false;
    } 
  
    return true;
}

function searchCompatibilities() {
    $("#errorDiv").addClass("d-none");
  
    var tool = getToolVal(); //$("#Tool").val();
    if(tool != null && tool != undefined && tool != "" && tool.indexOf("0x") <0){
      tool = getToolValueByText(tool);
    }
    var validEngine = $("#EngineType option").length > 1;
    var isValidForm = validateCoverageForm(validEngine);

    if (isValidForm) {        
        $("#searchCoverageBtn").attr('disabled','disabled');      
        $('#ModalContentAjax').modal("show");		

        var market = GetMarketVal();
		var year = $("#Year").val();
		var make = $("#Make").val();
		var modelName = $("#ModelName").val();
		var engineType = correctString($("#EngineType").val());				
        var forProductDetail = correctBool($("#ForProductDetail").val()); // || (tool != undefined && tool != "");
        var coverageSections = correctString($("#CoverageSections").val());      
        if(coverageSections == ""){
            coverageSections = checkTabletTool(tool) ? tabletDisplaySections : obdDisplaySections;
        }
		//var requestData = "ForProductDetail="+ forProductDetail +"&Tool="+tool +"&Year="+year + "&Make="+ make + "&ModelName=" + encodeURIComponent(modelName) + "&EngineType=" + encodeURIComponent(engineType) + "&sections=" + coverageSections;
        var requestData = {"Tool": tool,
                    "Year": year,
                    "Make": make,
                    "Model": modelName,
                    "EngineType": engineType,
                    "Market": market,
                    "sections": coverageSections,
                    "ForProductDetail": forProductDetail};
      try{       
          xhr = $.ajax({
              type: "POST",
              
              url: "/apps/innova-api/coverages/Search",
              cache: false,
              timeout: 15000,
              headers : {'Content-Type': 'application/json'},
              dataType: "json",
              data: JSON.stringify(requestData),
              //data: requestData, //$("#frmCoverage").serialize(),
              error: function (jqXHR, exception) {
                $('#ModalContentAjax').modal("hide");
                $("#searchCoverageBtn").removeAttr('disabled');
                if (jqXHR.status == 400){
                  alert(jqXHR.responseJSON.message.description);
                }else{
                  alert(getCannotLoadText(market));
                }
              },
              success: function (result) {
                if (result.message.success) {
                  if(result.data.hasData){
                      //render result
                      $("#results").html(result.data.coverageResult);	
                      
                      //replace disclaimer msg
                      const $target = $('#results p.text-center');
                      if ($target.length) $target.html(getDisclaimerMsg(market));

                      initDropdownPopup();
                      $("#searchCoverageBtn").removeAttr('disabled');
                      //edit view
                      switchSearchCondition("");                           
                  }else{        
                     var notfoundMsg = market.toLowerCase()=="mx" ? "Este vehículo no es compatible." : "This vehicle is not supported.";                                             
                     $("#results").html('<p class="alert alert-danger">'+ notfoundMsg +'</p>');	
                     $("#results").removeClass("d-none"); 
                  }
                  
                  currMarket = market;
                  currYear = year;
                  currMake = make;
                  currModel = modelName;
                  currEngine = engineType;
                  currTool = tool;
                } else {                                                               
                    $("#errorDiv").html(result.message.description);
                    $("#errorDiv").removeClass("d-none"); 
                }			
                $('#ModalContentAjax').modal("hide");
                $("#searchCoverageBtn").removeAttr('disabled');
              }
          });
     
        }catch(e)
        {
          $('#ModalContentAjax').modal("hide");
          $("#searchCoverageBtn").removeAttr('disabled');
        }      
    }

    return false;
}


function validateCoverage(validEngine) {
    $("#Year").addClass("required");
    $("#Make").addClass("required");
    $("#ModelName").addClass("required");
    if(validEngine){
      $("#EngineType").addClass("required");
    }else{
      $("#EngineType").removeClass("required").removeClass("inv-error");
    }

    if(!checkRequiredFields('coverageChecker')){
      return false;
    }  
  
    return true;
}

function checkCompatibilities() {
    $("#errorDiv").addClass("d-none");
    
    var tool = getToolVal();//$("#Tool").val();
    var validEngine = $("#EngineType option").length > 1;// && (tool == "" || !oldTools.includes(tool.toLowerCase()));
    var isValidForm = validateCoverage(validEngine);

    if (isValidForm) {
      var year = $("#Year").val();
      var make = encodeURIComponent($("#Make").val());
      var modelName = encodeURIComponent($("#ModelName").val());
      var engineType = $("#EngineType").val();
      var queryRequest = "tool="+ tool +"&year="+ year+"&make="+ make + "&modelName=" + modelName +"&engineType="+ engineType;
      window.location = "/pages/coverage?" + queryRequest; 
    }
    return false;
}

function queryDedault(){
  var tool = getToolValueByText(QUERY_STRING("tool")); 
  var year = QUERY_STRING("year"); 
  var make = decodeURIComponent(QUERY_STRING("make")); 
  var modelName = decodeURIComponent(QUERY_STRING("modelName")); 
  var engineType = QUERY_STRING("engineType"); 
  
  var market = GetMarketVal();
  var forProductDetail = (tool != undefined && tool != "");
 
  if(tool != null && tool != ""){
    $("#Tool").val(tool);
  }
  if((year != null && year != "") || (make != null && make != "")
     ||(modelName != null && modelName != "") || (engineType != null && engineType != "")){
    
    $("#Tool").val(tool);   
    if(year != null && year != ""){      
      $("#Year").val(year);
      var tool = getToolVal(); //$("#Tool").val();
      var year = $("#Year").val();
      if (year == "") {
          $("#Make").html("<option value=''>" + getMakeText(market) + "</option>");
          $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");
          $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
          $("#EngineType").change();
          $("#Make").change();
          $("#ModelName").change();
          return false;
      }
      $("#Make").html("<option value=''>" + getLoadingText(market) + "...</option>");
      var url = "/apps/innova-api/coverages/" + year + "/Makes/?r=" + Math.random();
      if(market != ""){
        url = "/apps/innova-api/coverages/"+ market +"/" + year + "/Makes/?r=" + Math.random();
      }

      $('#ModalContentAjax').modal("show");
      xhr = $.ajax({
          type: "GET",          
          url: url,
          cache: false,
          timeout: 15000,
          error: function (jqXHR, exception) {
            $('#ModalContentAjax').modal("hide");  
            if (jqXHR.status == 404){
              options = "<option value=''>" + getMakeText(market) + "</option>";
               $("#Make").html(options).change();
            }else if (jqXHR.status == 400){
              alert(jqXHR.responseJSON.message.description);
            }else{
              alert(getCannotLoadText(market));
            }
          },
          success: function (ret) {
            if (ret.message.success) {
              var result = ret.data;
              var options = "<option value=''>" + getMakeText(market) + "</option>"; 
              for (var i = 0; i < result.length; i++) {
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
              }
              $("#Make").html(options);
              $("#ModelName").html('<option value="">Model</option>');
              $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
              
              if(make != ""){ 
                $("#Make").val(make);                
    
                $("#ModelName").html("<option value=''>" + getLoadingText(market) + "...</option>");
                url = "/apps/innova-api/coverages/" + year + "/" + make + "/Models/?r=" + Math.random();
                if(market != ""){
                  url = "/apps/innova-api/coverages/"+ market +"/" + year + "/" + make + "/Models/?r=" + Math.random();
                }
                $.ajax({
                    type: "GET",                    
                    url: url,
                    cache: false,
                    timeout: 15000,
                    error: function (jqXHR, exception) {
                      $('#ModalContentAjax').modal("hide");
                      if (jqXHR.status == 404){
                        options = "<option value=''>" + getModelText(market) + "</option>";
                        $("#ModelName").html(options).change();
                      }else if (jqXHR.status == 400){
                        alert(jqXHR.responseJSON.message.description);
                      }else{
                        alert(getCannotLoadText(market));
                      }
                    },
                   success: function (ret) {
                      if (ret.message.success) {
                        var result = ret.data;
                        var options = "<option value=''>" + getModelText(market) + "</option>";
                        for (var i = 0; i < result.length; i++) {
                            options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                        }
                        $("#ModelName").html(options);
                        $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
                       
                        if(modelName != ""){ 
                          $("#ModelName").val(modelName);
                          
                          $("#EngineType").html("<option value=''>" + getLoadingText(market) + "...</option>");
                          url = "/apps/innova-api/coverages/" + year + "/" + make + "/" + encodeURIComponent(modelName) + "/engines/?r=" + Math.random();
                          if(market != ""){
                            url = "/apps/innova-api/coverages/"+ market +"/" + year + "/" + make + "/" + encodeURIComponent(modelName) + "/engines/?r=" + Math.random();
                          }
                          $.ajax({
                              type: "GET",                              
                              url: url,
                              cache: false,
                              timeout: 15000,
                              error: function (jqXHR, exception) {
                                $('#ModalContentAjax').modal("hide");
                                if (jqXHR.status == 404){
                                  options = "<option value=''>" + getEngineText(market) + "</option>";
                                  $("#EngineType").html(options).change();
                                }else if (jqXHR.status == 400){
                                  alert(jqXHR.responseJSON.message.description);
                                }else{
                                  alert(getCannotLoadText(market));
                                }
                              },
                              success: function (data) {
                                if (ret.message.success) {
                                  var result = ret.data;
                                  var options = result.length == 1? "": "<option value=''>" + getEngineText(market) + "</option>";
                                  for (var i = 0; i < result.length; i++) {
                                      options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                                  }
                                  $("#EngineType").html(options);
                                  //$('.selectpicker').selectpicker('refresh');

                                  if(engineType != ""){ 
                                    $("#EngineType").val(engineType);                                    
                                  }     
                                  
                                  //search coverage                                  
                          		  engineType = correctString(engineType);				
                                  var coverageSections = correctString($("#CoverageSections").val());      
                          		  var requestData = {"Tool": tool,
                                              "Year": year,
                                              "Make": make,
                                              "Model": modelName,
                                              "EngineType": engineType,
                                              "Market": market != "" ? market : "US",
                                              "sections": coverageSections,
                                              "ForProductDetail": forProductDetail};
                                                            
                                  xhr = $.ajax({
                                    type: "POST",
                                    url: "/apps/innova-api/coverages/Search",
                                    cache: false,
                                    timeout: 15000,
                                    headers : {'Content-Type': 'application/json'},
                                    dataType: "json",
                                    data: JSON.stringify(requestData),
                                    error: function (jqXHR, exception) {
                                      $('#ModalContentAjax').modal("hide");
                                      $("#searchCoverageBtn").removeAttr('disabled');
                                      if (jqXHR.status == 400){
                                        alert(jqXHR.responseJSON.message.description);
                                      }else{
                                        alert(getCannotLoadText(market));
                                      }
                                    },
                                    success: function (result) {
                                      if (result.message.success) {
                                        if(result.data.hasData){
                                            //render result
                                             $("#results").html(result.data.coverageResult);	

                                             //replace disclaimer msg
                                            const $target = $('#results p.text-center');
                                            if ($target.length) $target.html(getDisclaimerMsg(market));
                                            
                                            initDropdownPopup();
                                            $("#searchCoverageBtn").removeAttr('disabled');
                                            //edit view
                                            switchSearchCondition("");                           
                                        }else{
                                             var notfoundMsg = market.toLowerCase()=="mx" ? "Este vehículo no es compatible." : "This vehicle is not supported.";
                                             $("#results").html('<p class="alert alert-danger">'+ notfoundMsg +'</p>');	
                                             $("#results").removeClass("d-none"); 			 
                                        }                      
                                      } else {                                                               
                                          $("#errorDiv").html(result.message.description);
                                          $("#errorDiv").removeClass("d-none"); 
                                      }			
                                      $('#ModalContentAjax').modal("hide");
                                      $("#searchCoverageBtn").removeAttr('disabled');
                                    }
                                });                                
                              }
                              }
                          });
                        }
                    }
                    }
                });
              }
             
              $('#ModalContentAjax').modal("hide");
          }
          }
      });

    } 
    
  }
 
  return;
}

function loadTools(loadNewTool){
  var market = GetMarketVal();
  var toolList = loadNewTool ? newTools : mxTools;
  var items = "<option value='' >"+ getToolText(market) +"</option>";
  $.each(toolList, function (i, tool) {             
      items += "<option value='" + tool.val + "'>" + tool.text + "</option>";             
  });
  $("#Tool").html(items);  
  loadToolIds();
}

function loadToolIds(){
  var market = GetMarketVal();
  var items = "<option value='' >"+ getToolIdText(market) +"</option>";
  var toolText =$("#Tool option:selected").text();
  if(toolText != ""){
     var toolIds = newToolsIds.find(x => x.sku === toolText)?.toolids;
     if(toolIds != undefined){      
        $.each(toolIds, function (i, tool) {             
            items += "<option value='" + tool + "'>" + tool + "</option>";             
        });         
     }
  }
  $("#ToolId").html(items); 
}

function GetYearSelectList(selectedYear) {   
   var market = GetMarketVal();
  if(market !=''){
    var url = "/apps/innova-api/coverages/"+ market +"/Years/?r=" + Math.random();
    $.ajax({
        type: "GET",        
        url: url,
        cache: false,
        timeout: 15000,
        error: function (jqXHR, exception) {
            if (jqXHR.status == 404){
              options = "<option value=''>" + getYearText(market) + "</option>";
              $("#Year").html(options).change();
            }else if (jqXHR.status == 400){
              alert(jqXHR.responseJSON.message.description);
            }else{
              alert(getCannotLoadText(market));
            }
        },
        success: function (ret) {
          if (ret.message.success) {
            var result = ret.data;          
            var options = "<option value=''>" + getYearText(market) + "</option>";
            for (var i = 0; i < result.length; i++) {
              if( result[i] == selectedYear){
                options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
              }else{
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
              }              
            }
            $("#Year").html(options);
            $("#Make").html("<option value=''>" + getMakeText(market) + "</option>");
            $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");
            $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");

            switchSelectedInfo();
            //switchSelectedColor("Year");                     
          }
   
        }
    });
  }
}

function GetMakeSelectList(selectedMake) {
    var market = GetMarketVal();
    var year = $("#Year").val();
    if (year == "" || market == '') {
        $("#Make").html("<option value=''>" + getMakeText(market) + "</option>");
        $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");
        $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
        $("#EngineType").change();
        $("#Make").change();
        $("#ModelName").change();
        switchSelectedInfo();
        return false;
    }
    $("#Make").html("<option value=''>" + getLoadingText(market) + "...</option>");
    var url = "/apps/innova-api/coverages/"+ market +"/" + year + "/Makes/?r=" + Math.random();
    
    $('#ModalContentAjax').modal("show");
    xhr = $.ajax({
        type: "GET",        
        url: url,
        cache: false,
        timeout: 15000,
        error: function (jqXHR, exception) {
          $('#ModalContentAjax').modal("hide");  
          if (jqXHR.status == 404){
            options = "<option value=''>" + getMakeText(market) + "</option>";
             $("#Make").html(options).change();
          }else if (jqXHR.status == 400){
            alert(jqXHR.responseJSON.message.description);
          }else{
            alert(getCannotLoadText(market));
          }
        },
        success: function (ret) {
			if (ret.message.success) {
              var result = ret.data;
              var options = "<option value=''>" + getMakeText(market) + "</option>"; 
              for (var i = 0; i < result.length; i++) {
                if( result[i] == selectedMake){
                  options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
                }else{
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                }               
              }
              $("#Make").html(options);
              $("#ModelName").html('<option value="">'+ getModelText(market) +'</option>');
              $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
              
              switchSelectedInfo();
            
              // if(currModel != ""){
              //   GetModelSelectList(currModel);
              // }
            }else{
              $("#Make").html("<option value=''>" + getMakeText(market) + "</option>");             
            }
            $('#ModalContentAjax').modal("hide");
        }
    });

}

function GetModelSelectList(selectedModel) {
    var market = GetMarketVal();
    var make = $("#Make").val();
    var year = $("#Year").val();

    if (make == "" || year == "" || market == "") {
        $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");
        $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
        $("#EngineType").change();
        $("#ModelName").change();
        switchSelectedInfo();
        return false;
    }
    $("#ModelName").html("<option value=''>" + getLoadingText(market) + "...</option>");
    var url = "/apps/innova-api/coverages/"+ market +"/" + year + "/" + make + "/Models/?r=" + Math.random();

    $('#ModalContentAjax').modal("show");
    $.ajax({
        type: "GET",        
        url: url,
        cache: false,
        timeout: 15000,
        error: function (jqXHR, exception) {
            $('#ModalContentAjax').modal("hide");
            if (jqXHR.status == 404){
              options = "<option value=''>" + getModelText(market) + "</option>";
              $("#ModelName").html(options).change();
            }else if (jqXHR.status == 400){
              alert(jqXHR.responseJSON.message.description);
            }else{
              alert(getCannotLoadText(market));
            }
        },
        success: function (ret) {
          if (ret.message.success) {
            var result = ret.data;
            var options = "<option value=''>" + getModelText(market) + "</option>";
            for (var i = 0; i < result.length; i++) {
                if( result[i] == selectedModel){
                  options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
                }else{
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                }
            }
            $("#ModelName").html(options);
            $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
            //$('.selectpicker').selectpicker('refresh');

            switchSelectedInfo();
           
            // if(currEngine != ""){
            //   GetEngineTypeSelectList(currEngine);
            // }
          }else{
             $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");            
          }
          $('#ModalContentAjax').modal("hide");
        },
        complete: function (jqXHR, textStatus) {
            console.log("Complete - status:", textStatus);
            console.log("Complete - jqXHR:", jqXHR);
            // You can put retry logic here as fallback
        }
    });
}

function GetEngineTypeSelectList(selectedEngine) {
    var market = GetMarketVal();
    var make = $("#Make").val();
    var year = $("#Year").val();
    var model = $("#ModelName").val();

    if (make == "" || year == "" || model == "" || market == "") {
        $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
        $("#EngineType").change();
        switchSelectedInfo();
        return false;
    }
    $("#EngineType").html("<option value=''>" + getLoadingText(market) + "...</option>");
    var url = "/apps/innova-api/coverages/"+ market +"/" + year + "/" + make + "/" + encodeURIComponent(encodeURIComponent(model)) + "/engines/?r=" + Math.random();
        
  	$('#ModalContentAjax').modal("show");
    $.ajax({
        type: "GET",        
        url: url,
        cache: false,
        timeout: 15000,
        error: function (jqXHR, exception) {
            $('#ModalContentAjax').modal("hide");
            if (jqXHR.status == 404){
              options = "<option value=''>" + getEngineText(market) + "</option>";
              $("#EngineType").html(options).change();
            }else if (jqXHR.status == 400){
              alert(jqXHR.responseJSON.message.description);
            }else{
              alert(getCannotLoadText(market));
            }
        },
        success: function (ret) {
          if (ret.message.success) {
            var result = ret.data;
          	var options = result.length == 1? "": "<option value=''>" + getEngineText(market) + "</option>";
            for (var i = 0; i < result.length; i++) {
                if( result[i] == selectedEngine){
                  options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
                }else{
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                }
            }
            $("#EngineType").html(options);
            $("#EngineType").parent("div").parent("div").removeClass("d-none");
            switchSelectedInfo();  
          }else{
             $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
            if(ret.message.code = 1003){
              //Engine Not Found
               $("#EngineType").parent("div").parent("div").addClass("d-none");
            }
          
          }
          $('#ModalContentAjax').modal("hide");
        }
    });
}

function getToolTextByValue(toolVal){
   var tool = mxTools.find(x => x.val === toolVal)?.text;
   if(tool == undefined){
     tool = newTools.find(x => x.val === toolVal)?.text;
   }
  //var tool = newTools.find(x => x.val === toolVal)?.text;
  return tool == undefined ? toolVal : tool;
}

function getToolVal(){
	var tool = $("#ToolId").val();
    if (tool == null || tool == undefined || tool == ""){
        tool = $("#Tool").val();
    }
    return tool;
}

function getToolValueByText(toolText){
   var tool = mxTools.find(x => x.text === toolText)?.val;
   if(tool == undefined){
     tool = newTools.find(x => x.text === toolText)?.val;
   }
  //var tool = newTools.find(x => x.text === toolText)?.val;
  return tool == undefined ? toolText : tool;
}

function toggleCoverage(){
  	var tool =$("#Tool option:selected").text();
    if(tool == ""){
      tool = getToolTextByValue($("#Tool").val());
    }
	var coverageTools = $("#CoverageTools").val();
  	$("#coverageLink").addClass("d-none");
    $("#shopify-section-coverage-template").addClass("d-none"); 
  
    if(tool != undefined && tool != null && tool != "" && coverageTools != undefined && coverageTools != null && coverageTools != "" && 
       	coverageTools.toUpperCase().indexOf(tool.toUpperCase()) >= 0){
        $("#coverageLink").removeClass("d-none");
      	$("#shopify-section-coverage-template").removeClass("d-none");             
    }
}

function tongleFeatureCoverage(){
  var sku = QUERY_STRING("sku"); 
  if(sku == null || sku == undefined || sku == ""){
    sku = $("#Tool").val();
  }
  if(sku != null && sku != undefined && sku != "" && sku.indexOf("0x") <0){
    var tool = getToolValueByText(sku);     
    if(tool != undefined){
      $("#Tool").val(tool);
    }
  }
  
  //InitCoverageForTool();
  GetYearSelectList();
  var isTabletTool = checkTabletTool($("#Tool").val()); //tabletTools.every(item => { return item.toLowerCase() == $("#Tool").val().toLowerCase() });
  if(isTabletTool){
  	$("#featureCoverage").removeClass("d-none");    
    $("#coverageChecker").addClass("d-none");     
  }else{
  	$("#featureCoverage").addClass("d-none");    
    $("#coverageChecker").removeClass("d-none");
  }
}

function switchTab(tab){
  $("a.link").removeClass("inv-btn-solid-black").addClass("inv-btn-stroke");
  $("#" + tab + "Link").removeClass("inv-btn-stroke").addClass("inv-btn-solid-black");
  $("div.content").hide();
  $("#" + tab + "Tab").show();
  // $("div.content").addClass("d-none");
  // $("#" + tab + "Tab").removeClass("d-none");
}

function GetMarketVal() {
    var market = $("#Market").val();
    if (market == null || market == "" || market == undefined || market == "undefined") {
        market = "US";
    }
    return market;
}

function getMakeText(market){
  return market.toLowerCase() == "mx" ?  makeTextMX : makeText;
}

function getYearText(market){
  return market.toLowerCase() == "mx" ?  yearTextMX : yearText;
}

function getModelText(market){
  return market.toLowerCase() == "mx" ?  modelTextMX : modelText;
}

function getEngineText(market){
  return market.toLowerCase() == "mx" ?  engineTextMX : engineText;
}

function getToolText(market){
  return market.toLowerCase() == "mx" ?  toolTextMX : toolText;
}

function getToolIdText(market){
  return market.toLowerCase() == "mx" ?  toolIdMX : toolIdText;
}

function getLoadingText(market){
  return market.toLowerCase() == "mx" ?  loadingTextMX : loadingText;
}
function getCannotLoadText(market){
  return market.toLowerCase() == "mx" ?  cannotLoadAjaxMX : cannotLoadAjax;
}
function getDisclaimerMsg(market){
  return market.toLowerCase() == "mx" ?  disclaimerMsgMX : disclaimerMsg;
}

function isSupportOneTool() {
    var isWidget = $("#SupportOneTool").val();
    if (isWidget == null || isWidget == "" || isWidget == undefined || isWidget == "undefined") {
        isWidget = false;
    }
    return isWidget;
}
function checkTabletTool(tool){
  var isTabletTool = tabletTools.find(item => { return item.toLowerCase() == tool.toLowerCase() }) != undefined;
  return isTabletTool;
}

function correctString(val){
    return (val == undefined || val == null) ? "" : val;  
}

function correctBool(val){
      return (val == undefined || val == null) ? false : val.toLowerCase() === 'true';  
}
function initDropdownPopup() {     
  $(".inv-coverage2 .dropdown-menu").click(function(e){
	    e.stopPropagation();
	});	
	$(".inv-coverage2 .inv-dropdown-custom-close").click(function(e){
    var dropdownToggleEl = $(this).parent(".dropdown-menu").prev("a");
    const dropdownInstance = bootstrap.Dropdown.getOrCreateInstance(dropdownToggleEl);
    dropdownInstance.hide(); // Closes the dropdown
	    //$(".inv-coverage2 .inv-dropdown-custom").removeClass('open');
	});	 
}
function QUERY_STRING(key) {
  var val = "";
  query = window.location.search.substring(1);
  pairs = query.split("&");
  for (i = 0; i < pairs.length; i++) {
    pair = pairs[i].split("=");
    if (pair[0] == key) {
      val = decodeURI(pair[1]);
      break;
    }
  }
  return val;
}
